'use client'

import Image from 'next/image'

import { formatPrice } from 'modules/products'
import { isNotNilOrEmpty } from 'shared/utils/ramda'
import { addTestId } from 'shared/utils/tests'

import { getCartItemsPrice } from '../rules'
import { useDisplayCart } from '../store/cartStore'

import styles from './CartButton.module.scss'

interface CartButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  onClick: () => void
  isEcoVariant?: boolean
  open: boolean
}

const CartButton = ({ onClick, open }: CartButtonProps) => {
  const cart = useDisplayCart()
  const hasItems = isNotNilOrEmpty(cart?.items)

  const cartItemsQuantity = cart?.items?.length || 0

  const totalValue = getCartItemsPrice({
    paymentValue: cart?.paymentValue,
    deliveryPrice: cart?.deliveryCost
  })

  const totalPrice = formatPrice(totalValue)

  return (
    <button
      className={styles.wrapper}
      id='cart_button'
      onClick={onClick}
      role='button'
      aria-expanded={open}
      aria-controls='cart_drawer'
      {...addTestId('cart-drawer-trigger-button')}
    >
      <div className={styles.icon}>
        {hasItems ? (
          <p className={styles.productsNumber} id='productsNumber'>
            {cartItemsQuantity}
          </p>
        ) : null}
        <Image
          src={'/static/icons/basket.svg'}
          alt='basket'
          width={24}
          height={24}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.paragraph}>Koszyk</p>
        <div
          className={styles.amount}
          dangerouslySetInnerHTML={{
            __html: hasItems ? totalPrice : '0,00 zł'
          }}
        />
      </div>
    </button>
  )
}

export default CartButton
